import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonRadioGroupField, DropdownField } from '@cian/components';

import { IAppState, Dispatch } from '../../../../common/state';
import { EWCCount, EWCType } from '../../../../json_query';
import { changeWCCount, changeWCType } from '../../../state/advanced/wc';
import { InlineBlock, InlineLabel, InlineParam, Row } from '../markup';

interface IWCProps {
  wc_type: EWCType;
  onWCTypeChanged(wcType: EWCType, wcCount: EWCCount): void;

  wc_count: EWCCount;
  onWCCountChanged(wcType: EWCType, wcCount: EWCCount): void;
}

const getChangedWCType = (value: string): EWCType => {
  if (value === 'Separated') {
    return EWCType.Separated;
  } else if (value === 'United') {
    return EWCType.United;
  } else {
    return EWCType.Any;
  }
};

const wc: React.StatelessComponent<IWCProps> = props => {
  let radioGroupValue = '';
  if (props.wc_type === EWCType.Separated) {
    radioGroupValue = 'Separated';
  }
  if (props.wc_type === EWCType.United) {
    radioGroupValue = 'United';
  }

  return (
    <Row title="Санузел">
      <InlineParam>
        <ButtonRadioGroupField
          uncheckable
          value={radioGroupValue}
          onValueChange={value => props.onWCTypeChanged(getChangedWCType(value), props.wc_count)}
          values={[
            { value: 'United', label: 'Совмещенный' },
            { value: 'Separated', label: 'Раздельный' },
          ]}
        />
      </InlineParam>
      <InlineLabel>&nbsp; количество:</InlineLabel>
      <InlineBlock>
        <DropdownField
          value={props.wc_count}
          onValueChange={(wcCount: EWCCount) => props.onWCCountChanged(props.wc_type, wcCount)}
          values={[
            { value: EWCCount.Any, label: 'неважно' },
            { value: EWCCount.One, label: 'от 1' },
            { value: EWCCount.Two, label: 'от 2' },
            { value: EWCCount.Three, label: 'от 3' },
            { value: EWCCount.Four, label: 'от 4' },
          ]}
        />
      </InlineBlock>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const jq = state.filters.jsonQuery;

    return {
      wc_type: (jq.wc_type && jq.wc_type.value) || EWCType.Any,
      wc_count: jq.isWCfixed ? EWCCount.Any : (jq.wc && jq.wc.value.gte) || EWCCount.Any,
    };
  },
  (dispatch: Dispatch) => ({
    onWCTypeChanged: (wcType: EWCType, wcCount: EWCCount) => {
      dispatch(changeWCType(wcType, wcCount));
    },
    onWCCountChanged: (wcType: EWCType, wcCount: EWCCount) => {
      dispatch(changeWCCount(wcType, wcCount));
    },
  }),
)(wc);
